'use strict';
const attributesForCleanup = ['previous-atlas-export', 'watermark-bytes'],
	needsCleanup = function (sourceContent) {
		return sourceContent?.attr && attributesForCleanup.find(a => sourceContent.attr[a]);
	};
module.exports = function cleanUpContentForExport(sourceContent) {
	if (!needsCleanup(sourceContent)) {
		return sourceContent;
	}
	const contentClone = JSON.parse(JSON.stringify(sourceContent));
	for (const a of attributesForCleanup) {
		delete contentClone.attr[a];
	}
	return contentClone;
};
